import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/kategorien-gebuehren/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="FeeCategories"
      returnRoute="/auswahlfelder/feeCategories"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const FeeCategoriesRoute = Route;
